import type { MouseEvent } from 'react';
import { BellIcon } from './ui/BellIcon';
import { devLog } from '../utils/logger';


interface NotificationBellProps {
  unreadCount: number;
  onClick: (anchorRect?: {
    top: number;
    right: number;
    bottom: number;
    left: number;
    width: number;
    height: number;
  }) => void;
  hasUnread: boolean;
}

export function NotificationBell({ unreadCount, onClick, hasUnread }: NotificationBellProps) {
  devLog('🔔 NotificationBell rendered - unreadCount:', unreadCount, 'hasUnread:', hasUnread);
  
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    devLog('🔔 NotificationBell clicked!');
    const rect = e.currentTarget.getBoundingClientRect();
    onClick({
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height,
    });
  };
  
  return (
    <button
      onClick={handleClick}
      className="relative p-2 rounded-full hover:bg-purple-50 transition-colors"
      aria-label="Varsler"
    >
      <BellIcon 
        size={20} 
        className={hasUnread ? 'text-purple-600' : 'text-gray-600'} 
      />
      
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full min-w-[20px] text-center shadow-md font-medium">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
